import { generatePath } from 'react-router-dom'
import { BRAND_PLAN_PATH, CAMPAIGNS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Timeline } from 'blaze-ui/icons'
import { Workspace } from 'types'
import { useCampaignsEnabled } from 'hooks/queries/brandPlans/useCampaignsEnabled'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Layers5 } from 'blaze-ui/icons/24'
import { DesktopBadge } from '../DesktopBadge/DesktopBadge'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuBrandPlanItem = ({ workspace, onPress }: Props) => {
  const isCampaignsEnabled = useCampaignsEnabled()
  const isSystemRedesignEnabled = useIsSystemRedesign()

  const to = isCampaignsEnabled
    ? generatePath(CAMPAIGNS_PATH, { workspaceId: workspace.id })
    : generatePath(BRAND_PLAN_PATH, { workspaceId: workspace.id })

  if (isSystemRedesignEnabled) {
    return <NavMenuItem icon={Layers5} activeIcon={Layers5} to={to} onPress={onPress} label="Content Plan" />
  }

  return (
    <NavMenuItem icon={Timeline} activeIcon={Timeline} to={to} onPress={onPress} label="Content Plan">
      <DesktopBadge />
    </NavMenuItem>
  )
}

export { NavMenuBrandPlanItem }
